import { generateUUID } from '@functions/functions';
import { INewPrompt, IPrompt } from './Prompt.type';

function addPrompt<TPrompt = IPrompt, TNewPrompt = INewPrompt>(prompts: TPrompt[], newPrompt: TNewPrompt): TPrompt[] {
	return [
		...prompts,
		{
			id: generateUUID(),
			...newPrompt
		} as TPrompt
	];
}

function addPromptIfNotAlreadyIn<TPrompt = IPrompt, TNewPrompt extends Object = INewPrompt>(
	prompts: TPrompt[],
	newPrompt: TNewPrompt,
	uniqueKey: keyof TPrompt
): TPrompt[] {
	const matchingKey = Object.keys(newPrompt).find((key) => key === uniqueKey) as keyof TNewPrompt | undefined;

	if (!matchingKey) {
		console.error(`addPromptIfNotAlreadyIn: ${String(uniqueKey)} is not a valid key in newPrompt.`);

		return prompts;
	}

	const typedNewPrompt = {
		id: generateUUID(),
		...newPrompt
	} as TPrompt;

	// compare two array to check if they are the same
	if (Array.isArray(typedNewPrompt[uniqueKey])) {
		const strArr = JSON.stringify(typedNewPrompt[uniqueKey]);

		if (prompts.some((prompt) => JSON.stringify(prompt[uniqueKey]) === strArr)) {
			console.warn(
				`addPromptIfNotAlreadyIn (key => value is an array): ${String(uniqueKey)} already exists in prompts.`
			);
			// is already in the array so we don't add it
			return prompts;
		}
	} else {
		if (prompts.some((prompt) => prompt[uniqueKey] === typedNewPrompt[uniqueKey])) {
			console.warn(`addPromptIfNotAlreadyIn: ${String(uniqueKey)} already exists in prompts.`);
			// is already in the array so we don't add it
			return prompts;
		}
	}

	return [...prompts, typedNewPrompt];
}

export { addPrompt, addPromptIfNotAlreadyIn };
